import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { ReportField } from '@core/models/interfaces/report-field';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { CustomDialogComponent } from '../custom-dialog/custom-dialog.component';
import { ButtonComponent } from '../button/button.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-report-field-selection',
  standalone: true,
  imports: [
    DialogModule,
    CheckboxModule,
    CustomDialogComponent,
    ButtonComponent,
    TranslateModule,
    FormsModule
  ],
  templateUrl: './report-field-selection.component.html',
  styleUrl: './report-field-selection.component.scss'
})
export class ReportFieldSelectionComponent {
  @Input() visible: boolean = false;
  @Input() data: ReportField[]= []
  @Input() requiredFields: string[] = [];
  @Input() isAllFieldSelected: boolean = true;

  @Output() visibleChange = new EventEmitter(false);
  @Output() dataChange = new EventEmitter();
  @Output() isAllFieldSelectedChange = new EventEmitter()

  localData: ReportField[] = []
  localIsAllSelected: boolean = true;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['visible']?.currentValue === true) {
      this.localData = this.data.map(item => ({
        ...item,
        isSelected: item.isSelected ?? false
      }));

      this.localIsAllSelected =
        this.localData.length > 0 &&
        this.localData.every(
          f => f.isSelected || this.isRequiredField(f)
        );
    }
  }

  onVisibleChange(visible: boolean) {
    this.visible = visible;
    this.visibleChange.emit(this.visible);
  }

  isRequiredField(field: ReportField) {
    return this.requiredFields.includes(field.key)
  }

  onToggleAll() {
    this.localData.forEach(f => {
      if (!this.isRequiredField(f)) {
        f.isSelected = this.localIsAllSelected;
      }
    });
  }

  onItemChanged() {
    this.localIsAllSelected =
      this.localData.length > 0 &&
      this.localData.every(f => f.isSelected || this.isRequiredField(f));
  }

  exportSelectedFieldsList() {
    return this.localData.filter(e => e.isSelected === true).map(e => e.key)
  }

  get exportSelectedFieldsText(): string {
    return `Select fields (${this.localIsAllSelected ? 'All' : this.exportSelectedFieldsList().length})`
  }

  onSave() {
    this.isAllFieldSelectedChange.emit(this.localIsAllSelected)
    this.dataChange.emit(this.localData)
    this.onVisibleChange(false)
  }
}
